import { CompetitionDivisionWriteRequest, PatchedCompetitionDivisionWriteRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateCompetitionDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: CompetitionDivisionWriteRequest) => SSF.api.competitionDivisionsCreate(payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function usePartialUpdateCompetitionDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: PatchedCompetitionDivisionWriteRequest }) =>
      SSF.api.competitionDivisionsPartialUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteCompetitionDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.competitionDivisionsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
